module.exports = __webpack_public_path__ + "static/assets/36fcc7dbca20720abcab01e49d4955f9.svg";